import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const PointsCell = ({getValue, column: {id: columnName}}) => {
  const value = getValue()

  const color = columnName === 'mCoins' ? 'mld.neutral.800' : 'mld.neutral.1000'
  const fontWeight = columnName === 'mCoins' ? 'medium' : 'normal'

  return (
    <Box fontWeight={fontWeight} color={color} width="100%" display="block">
      {value != null ? value.toLocaleString() : '0'}
    </Box>
  )
}

PointsCell.propTypes = {
  getValue: PropTypes.func.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default PointsCell
